import React, { useEffect, useState } from 'react'
import DataTableLayer from '../../components/DataTableLayer'
import ModalAlert from '../../components/ModalAlert';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import ChannelForm from './ChannelForm';
import PostByAgg from '../../utils/axios';
import LottieLoading from '../../components/child/LottieLoading';
const Channel = () => {

    const [openForm, setOpenForm] = useState(false)
    const [actionMode, setActionMode] = useState('create');
    const [selectedChannel, setSelectedChannel] = useState(null);  
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    })
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [openModalError, setOpenModalError] = useState(<div></div>)
    const [showSuccessModal, setShowSuccessModal] = useState(false);


const columns = [
    {
        header:'Nama Channel',
        accessorKey: "channel_name",
    },
    {
        header : 'Status',
        accessorKey:'is_active',
        cell: ({row}) => {
            const status = row.getValue('is_active');
            let badgeColor;
            if(status === true){
                badgeColor = 'bg-success';
            }else{
                badgeColor = 'bg-secondary';
            }
            return (
               <span className={`badge ${badgeColor}`}>
                    {status ? 'Active' : 'Inactive'}
                </span>
            )
        }
    },
    {
        header: 'Created By',
        accessorKey: "created_by",
    },
    {
        header: 'Created At',
        accessorKey: "created_at",
    },
    {
        accessorKey: "action", // Add a custom column for actions
        header: "Actions",
        cell: ({ row }) => (
            <div className="dropdown">
                <button
                    className="btn px-18 py-11 text-primary-light"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <Icon
                        icon="ph:dots-three-outline-fill"
                        className="menu-icon"
                    />
                </button>
                <ul className="dropdown-menu">
                    <li>
                        <Link
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                            to="#"
                            onClick={() => handleAction('view', row.original)}
                        >
                            View
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                            to="#"
                            onClick={() => handleAction('update', row.original)}
                        >
                            Update
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                            to="#"
                            onClick={()=> handleAction('delete', row.original)}
                        >
                            Delete
                        </Link>
                    </li>
                    
                </ul>
            </div>
        ),
    },
]

const getListChannel = () => {
    setIsLoading(true);
    const url ='song/v1/channel/list'
    PostByAgg({
        url:url,
        body:
            {
                "page" : pagination.pageIndex + 1, 
                "page_size" : pagination.totalRecords,
                "keyword" : ""
            },
        onResponse:onResponseChannel,
        onError: onErrorChannel
    })
}

const onResponseChannel = (response) => {
    console.log("List Channel",response.data.data);
    if(response.data.code === "2002000" || response.data.data.length > 0){
        const totalRecords = response.data.data.total_records;
        const totalPages = Math.ceil(totalRecords / pagination.pageSize);
        setPagination((prev) => ({
            ...prev,
            totalRecords: totalRecords,
            totalPages: totalPages,
            pageSize: totalRecords,
            // pageIndex: 0,
        }));
        setIsLoading(false)
        setData(response.data.data.data);
    }else{
        setIsLoading(false)
        setData([]);
    }
}

const onErrorChannel = (error) => {
    console.error('Error:', error);
    if(error.response.data.code === "4003400"){
        setOpenModalError(
            <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data.message.id}
                action={() => {}}
            />
        )
    }
}

useEffect(() => {
    getListChannel();
}, [pagination.pageIndex, pagination.pageSize]);

const handleAdd = () => {
    setActionMode('create');
    setSelectedChannel(null);
    setOpenForm(true);
}

const handleClose = () => {
    setOpenForm(false);
};
const handleAction = (action, row) => {
    console.log(`Action: ${action}`);
    setActionMode(action);
    setSelectedChannel(row);
    console.log("Selected Row:", selectedChannel); // Set selected user data
    if (action === 'delete') {
        setSelectedRow(row);
        setShowConfirmModal(true);
        console.log("Selected Row for Deletion:", selectedRow);
    } else if(action === 'update'){ 
        setSelectedRow(row);
        setOpenForm(true); 
    }else{
        setOpenForm(true);
    }
};

const handleDelete = (userId) => {
    console.log('Deleting user with ID:', userId);
    setShowConfirmModal(false);
    const url = 'song/v1/channel/delete';
    PostByAgg({
        url,
        body: {
            "channel_code" : selectedRow.channel_code,
            "updated_by" : "admin"
        },
       onResponse: onResponseDelete,
       onError: onErrorDelete
    })

};

const onResponseDelete = (response) => {
    console.log("Delete Channel",response.data.data);
   if(response.data.code === "2002000"){
    console.log("Data has been deleted successfully!");
    setShowSuccessModal(
        <ModalAlert
            show={true}
            type={"success"}
            text={response.data.message.id}
            action = {() => {
                setShowSuccessModal(<div></div>);
                getListChannel();
                setOpenForm(false);
            }}
            />
    )
   }
}

const onErrorDelete = (error) => {
    console.error('Error:', error);
    if(error.response.data.code === "4003400"){
        setOpenModalError(
            <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data.message.id}
                action={() => {
                    setShowSuccessModal(<div></div>);
                }}
            />
        )
    }else{
        setOpenModalError(
            <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data.message.id}
                action={() => {
                    setShowSuccessModal(<div></div>);
                    
                }}
            />
        )
    }
}


  return (
    <div>
        <DataTableLayer data={data} title={'Channels Table'} columns={columns} showButton={true} btnTitle={'Add'} onClick={handleAdd}/>
        {
            openForm && (
                <ChannelForm
                open={openForm}
                mode={actionMode}
                channel={selectedChannel} // Pass selected user data
                handleClose={handleClose}
                refreshData={getListChannel}
                />
            )
        }
        {showConfirmModal && (
                <ModalAlert
                    show={true}
                    type="confirm"
                    code="Delete Confirmation"
                    text={`Are you sure you want to delete this channel: ${selectedRow.channel_name}?`}
                    open={showConfirmModal}
                    action={() => {
                        handleDelete(selectedRow.channel_name);
                    }}
                    cancel={() => setShowConfirmModal(false)}
                />
            )}

        {isLoading && <LottieLoading text="Loading..." />}
        {showSuccessModal}
        {openModalError}
    </div>
  )
}

export default Channel